import * as React from 'react'
import { IFileInfo } from 'library/types/IFileInfo';
import { SystemBase } from 'library/common/SystemBase';
import { toast } from 'react-toastify';
import { getGlobalSettings } from '../../service/userService';

interface ISystemUpload {
    onFileChanged?(fileInfo: IFileInfo): void
    /*Specifies the allowed extension of the component.*/
    extension: string,
    /*Specifies height of the component.*/
    height: string,
    /*Specifies width of the component.*/
    width: string,
    /*Specifies text of the component when image url not set.*/
    alt: string
    /**/
    showImage?: boolean
    fileInfo?: IFileInfo, className?: string,
    FileBase64?: boolean
}
/**
 * Creates an Input with Label  
 * */
export default class SystemUpload extends SystemBase<ISystemUpload>
{
    constructor(props: any) {
        super(props)
    }

    static defaultProps = {
        ...SystemBase.defaultProps,
        showImage: true,
        FileBase64: false,
        showDimensionMessage: false
    } as ISystemUpload;

    getfile2Base64 = (file: File): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result ? reader.result.toString() : "");
            reader.onerror = error => reject(error);
        })
    }

    validateFile(fileExtension: string, fileSize: number): boolean {
        let resp = null;// getGlobalSettings();
        var filterMaxAttachmentSize = resp.filter(x => x.Name == "DefaultFileSizeLimit")
        var MaxAttachmentSize = 0;
        MaxAttachmentSize = filterMaxAttachmentSize[0].SettingValue;
        var filter = resp.filter(x => x.Name == "SupportedFileFormat")
        var FileSize = 0, OriginalFileSize = 0;
        var fileExtsetting = filter[0].SettingValue.split(',');
        for (var i = 0; i < fileExtsetting.length; i++) {
            var splitvalue = fileExtsetting[i].split(':');
            for (var j = 0; j < splitvalue.length; j++) {
                if (fileExtension.toLowerCase() == "pdf") {
                    if (splitvalue[0].toLowerCase() == "pdf") {
                        OriginalFileSize = splitvalue[1];
                        FileSize = splitvalue[1] * 1048576;
                    }
                }
                else if (fileExtension.toLowerCase() == "doc") {
                    if (splitvalue[0].toLowerCase() == "doc") {
                        OriginalFileSize = splitvalue[1];
                        FileSize = splitvalue[1] * 1048576;
                    }
                }
                else if (fileExtension.toLowerCase() == "docx") {
                    if (splitvalue[0].toLowerCase() == "docx") {
                        OriginalFileSize = splitvalue[1];
                        FileSize = splitvalue[1] * 1048576;
                    }
                }
                else if (fileExtension.toLowerCase() == "xls") {
                    if (splitvalue[0].toLowerCase() == "xls") {
                        OriginalFileSize = splitvalue[1];
                        FileSize = splitvalue[1] * 1048576;
                    }
                }
                else if (fileExtension.toLowerCase() == "xlsx") {
                    if (splitvalue[0].toLowerCase() == "xlsx") {
                        OriginalFileSize = splitvalue[1];
                        FileSize = splitvalue[1] * 1048576;
                    }
                }
                else if (fileExtension.toLowerCase() == "jpg" || fileExtension.toLowerCase() == "jpeg" || fileExtension.toLowerCase() == "png" || fileExtension.toLowerCase() == "bmp") {
                    if (splitvalue[0].toLowerCase() == "jpg" || splitvalue[0].toLowerCase() == "jpeg" || splitvalue[0].toLowerCase() == "png" || splitvalue[0].toLowerCase() == "bmp") {
                        OriginalFileSize = splitvalue[1];
                        FileSize = splitvalue[1] * 1048576;
                    }
                }
            }
        }

        if (FileSize == 0) {
            OriginalFileSize = MaxAttachmentSize;
            MaxAttachmentSize = MaxAttachmentSize * 1048576;
        }

        const maxFileSize = FileSize != 0 ? FileSize : MaxAttachmentSize;
        if (fileSize > maxFileSize) {
            toast.info("File is too large. The maximum file size allowed is " + OriginalFileSize + 'MB');
            return false;
        }

        var fileExt = this.props.extension.split(',');
        if (!(fileExt && fileExt.length > 0 && fileExt.find(element => element.toLowerCase() == '.' + fileExtension.toLowerCase()))) {
            toast.info("File extension not supported. File extension(s) supported are " + this.props.extension);
            return false;
        }
        return true;
    }

    handleChange = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            let fileData = event.target.files[0];
            let fileSize = fileData.size;
            let fileType = fileData.type;
            let filename = fileData.name;
            let fileExtension = filename.split('.').pop();
            if (this.validateFile(fileExtension, fileSize)) {
                this.getfile2Base64(fileData).then((response: any) => {
                    let fileBase64 = response.replace('data:', '').replace(/^.+,/, '');
                    this.setState({
                        imagePath: response
                    });


                    if (this.props.onFileChanged)
                        this.props.onFileChanged({
                            fileSize: fileSize,
                            fileType: fileType,
                            filename: filename,
                            fileExtension: fileExtension,
                            fileBase64: fileBase64,
                            fileBase64Url: response,

                        });
                })
            }

        }
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.value) this.setImagePath();

    }

    componentDidUpdate(prevProps: any) {
        super.componentDidUpdate(prevProps);

        if (prevProps.fileInfo != this.props.fileInfo && !this.props.fileInfo) {

            var fileinput = document.getElementById("fileUploadImage-" + this.props.id) as HTMLInputElement
            if (fileinput) fileinput.value = '';
            this.setState({ imagePath: '' });
        }

        if (prevProps.value != this.props.value) {
            this.setImagePath();
        }

    }

    setImagePath = () => {
        let ImageUrl = '';
        const ImageUrlRoot = config.ImageServerUrl;

        if (this.props.FileBase64) {
            ImageUrl = 'data:image/png;base64,' + this.props.value;

            if (this.props.value) this.setState({ imagePath: ImageUrl as string });
        }
        else {
            ImageUrl = ImageUrlRoot + this.props.value;

            if (this.props.value) this.setState({ imagePath: ImageUrl as string });
        }

    }

    handelButtonChange = (event: any) => {
        var inputContrlId = document.getElementById("fileUploadImage-" + this.props.id);
        if (inputContrlId)
            inputContrlId.click();
    }
    render() {
        var finfo = this.state.value as IFileInfo;
        return (
            <this.WrapperDiv>
                <input type="file" style={{ display: "none" }}
                    id={"fileUploadImage-" + this.props.id}
                    name="fileUploadImage"
                    className={this.props.className || 'from-control'}
                    accept={this.props.extension}
                    onChange={this.handleChange}

                //onFocus={this.handleFocus}
                //onBlur={this.handleBlur}
                />

                {this.props.showImage ?
                    <div className="previewImg">
                        <img src={this.state.imagePath || avatar} alt={this.props.alt} height={this.props.height} width={this.props.width} />
                        <div className="file_upload_btn"> <input type="button" id={this.props.id} name={this.props.name} value={this.props.label} className="file_upload" title={this.props.label} onClick={this.handelButtonChange} /></div>
                        {this.props.showDimensionMessage ? <div className="col-form-label pt-2"><label>Recommended size is 200px by 100px and aspect ratio is 2:1</label></div> : null}
                    </div>
                    : <input type="button" id={this.props.id} name={this.props.name} value={this.props.label} className="file_upload" title={this.props.label} onClick={this.handelButtonChange} />
                }
            </this.WrapperDiv>
        );
    }
}

